export default __webpack_public_path__ + "static/media/icon_portal.bf60ab40.svg";